import { memo } from "react";
import { Button } from "../ui/button";
import { X } from "lucide-react";

export interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileName: string | null;
}

const ConfirmModal = memo(({ isOpen, onClose, onConfirm, fileName }: ConfirmModalProps) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content upload-modal"
        style={{
          minWidth: 380,
          maxWidth: 440,
          padding: '40px 32px 32px 32px',
          borderRadius: 20,
          minHeight: 0,
          maxHeight: '32vh',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 style={{ fontSize: '1.45rem', fontWeight: 700, margin: 0 }}>Usuń plik</h2>
          <button className="close-button" style={{ marginLeft: 12 }} onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div style={{
          margin: '0px 0 32px 0',
          color: '#1a1a1a',
          fontSize: 20,
          fontWeight: 700,
          textAlign: 'center',
          width: '100%',
          lineHeight: 1.35,
          letterSpacing: '-0.5px',
        }}>
          Czy usunąć <span style={{ color: '#2563eb', fontWeight: 800 }}>{fileName}</span>?
        </div>
        <div className="modal-footer" style={{ gap: 16, marginTop: 0 }}>
          <Button className="outline-button" style={{ padding: '10px 24px', fontSize: 16 }} onClick={onClose}>Anuluj</Button>
          <Button className="upload-button" style={{ background: '#ef4444', padding: '10px 24px', fontSize: 16 }} onClick={onConfirm}>Usuń</Button>
        </div>
      </div>
    </div>
  );
});

export default ConfirmModal; 